"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _OldButtonComponent.default;
  }
});

var _OldButtonComponent = _interopRequireDefault(require("./OldButton-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }